import { createAsyncTypes } from 'store/utils';

// State Key
export const KEY = 'venues';

// Action Types
export const types = {
  GET_VENUES: createAsyncTypes(`${KEY}/GET_VENUES`),
  CREATE_VENUE: createAsyncTypes(`${KEY}/CREATE_VENUE`),
  UPDATE_VENUE: createAsyncTypes(`${KEY}/UPDATE_VENUE`),
  DELETE_VENUE: createAsyncTypes(`${KEY}/DELETE_VENUE`),
  RESET_ACTION: `${KEY}/RESET_ACTION`,
  RESET_ERROR: `${KEY}/RESET_ERROR`
};

export interface Venue {
  id: string;
  clientId: string;
  name: string;
  createdAt: string;
  updatedAt: string;
  address: string;
  lowTicketAlertThresholds: number[];
}

export interface VenuesState {
  readonly venues: Venue[];
  readonly action: {
    readonly pending: boolean;
    readonly success: boolean;
    readonly error: string | null;
  };
}

export interface CreateVenuePayload {
  name: string;
  lowTicketAlertThresholds?: number[];
  address?: string;
}

export interface GetVenuesRequest {
  type: typeof types.GET_VENUES.REQUEST;
}

export interface GetVenuesPending {
  type: typeof types.GET_VENUES.PENDING;
  payload: boolean;
}

export interface GetVenuesSuccess {
  type: typeof types.GET_VENUES.SUCCESS;
  payload: Venue[];
}

export interface GetVenuesError {
  type: typeof types.GET_VENUES.ERROR;
  payload: string;
}

export interface CreateVenueRequest {
  type: typeof types.CREATE_VENUE.REQUEST;
  payload: CreateVenuePayload;
}

export interface CreateVenuePending {
  type: typeof types.CREATE_VENUE.PENDING;
  payload: boolean;
}

export interface CreateVenueSuccess {
  type: typeof types.CREATE_VENUE.SUCCESS;
  payload: Venue;
}

export interface CreateVenueError {
  type: typeof types.CREATE_VENUE.ERROR;
  payload: string;
}

export type UpdateVenuePayload = Partial<Venue> & { id: string };

export interface UpdateVenueRequest {
  type: typeof types.UPDATE_VENUE.REQUEST;
  payload: UpdateVenuePayload;
}

export interface UpdateVenuePending {
  type: typeof types.UPDATE_VENUE.PENDING;
  payload: boolean;
}

export interface UpdateVenueSuccess {
  type: typeof types.UPDATE_VENUE.SUCCESS;
  payload: Venue;
}

export interface UpdateVenueError {
  type: typeof types.UPDATE_VENUE.ERROR;
  payload: string;
}

export interface DeleteVenueRequest {
  type: typeof types.DELETE_VENUE.REQUEST;
  payload: { id: string };
}

export interface DeleteVenuePending {
  type: typeof types.DELETE_VENUE.PENDING;
  payload: boolean;
}

export interface DeleteVenueSuccess {
  type: typeof types.DELETE_VENUE.SUCCESS;
}

export interface DeleteVenueError {
  type: typeof types.DELETE_VENUE.ERROR;
  payload: string;
}

export interface ResetAction {
  type: typeof types.RESET_ACTION;
}

export interface ResetError {
  type: typeof types.RESET_ERROR;
}

export type VenuesActionTypes =
  | GetVenuesRequest
  | GetVenuesPending
  | GetVenuesSuccess
  | GetVenuesError
  | UpdateVenueRequest
  | UpdateVenuePending
  | UpdateVenueSuccess
  | UpdateVenueError
  | CreateVenueRequest
  | CreateVenuePending
  | CreateVenueSuccess
  | CreateVenueError
  | DeleteVenueRequest
  | DeleteVenuePending
  | DeleteVenueSuccess
  | DeleteVenueError
  | ResetAction
  | ResetError;
